<div class="search-container">
  <form class="form-search-bar" [formGroup]="searchForm" (ngSubmit)="handleSubmit()" autocomplete="off">

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'admin.dialogs.description' |translate}}</mat-label>
      <input matInput type="text" [formControl]="descriptionControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'admin.templates.category' |translate}}</mat-label>
      <mat-select [formControl]="categoryControl">
        <mat-option *ngFor="let category of templateCategories" [value]="category.id">{{category.description}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'admin.templates.subject' |translate}}</mat-label>
      <input matInput type="text" [formControl]="subjectControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'admin.countries.status' |translate}}</mat-label>
      <mat-select [formControl]="statusControl">
        <mat-option value="">-</mat-option>
        <mat-option value="ACTIVE">Active</mat-option>
        <mat-option value="INACTIVE">Inactive</mat-option>
      </mat-select>
    </mat-form-field>

    <button type="reset" mat-raised-button (click)="clean()">Clean</button>
    <button type="submit" mat-raised-button color="primary">Apply</button>
  </form>
</div>
